import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeCreateTherapyPrescriptionMutation as useDeCreateTherapyPrescriptionMutationType } from "@/modules/patients/detail/therapy-prescription/de/services/__generated__/useDeCreateTherapyPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useDeCreateTherapyPrescriptionMutation($input: De_createTherapyPrescriptionInput!) {
    de_createTherapyPrescription(input: $input) {
      de_TherapyPrescription {
        id
        ...deTherapyPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeCreateTherapyPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeCreateTherapyPrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeCreateTherapyPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeCreateTherapyPrescriptionMutation }
